import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnonymizationLevelOption from '../AnonymizationLevelOption';
import { anonymizationOptionsConfig } from 'configs';
import {
	Form,
	EditNavLink,
	StyledSection as Section,
	FormHeader,
	FormTitle,
	FormDescription,
} from './styles';

const EDIT_LINK_URL = '/settings/archive/edit/anonymization';

export class AnonymizationLevelSectionBase extends Component {
	static propTypes = {
		exportedMetadata: PropTypes.any,
	};

	render() {
		const { exportedMetadata } = this.props;
		const anonymizationLevel = exportedMetadata.anonymizationLevel || {};
		const optionValue = anonymizationOptionsConfig.find(item => {
			return item.value === anonymizationLevel.key;
		});
		return (
			<Form>
				<FormHeader>
					<FormTitle>Anonymization level set</FormTitle>
					<FormDescription>
						You have set your anonymization level as per your Engagement Letter
						as below. Please now contact your Client Support Team contact who
						will anonymize your engagement data and complete the storage process
						for you.
					</FormDescription>
				</FormHeader>
				<Section animationIndex={1} title="Anonymization level">
					<EditNavLink to={EDIT_LINK_URL}>Edit Anonymization level</EditNavLink>
					{exportedMetadata.anonymizationLevel && (
						<AnonymizationLevelOption
							key={1}
							keyValue={1}
							onChange={() => {}}
							checked={true}
							{...optionValue}
						/>
					)}
				</Section>
			</Form>
		);
	}
}
